import {
  Activity,
  ActivityFeedItemDefinition,
} from "@ofqual/portal-activity-feed";
import { useSelector } from "react-redux";
import { authSelector } from "../../redux/selectors";
import { EmailActivityBody, DialogType } from "./types";
import { DownloadLink } from "@ofqual/portal-components/components/DownloadLink";
import { ActivityType } from "../../domain/ActivityType";
import { Typography } from "@material-ui/core";
import { sarsService } from "../../services";
import { SarsModel } from "../../domain/SarsModel";
import ReactMarkdown from "react-markdown";
import { useLookup } from "@ofqual/portal-core/core/hooks";

export const buildDefinitions = (
  setFocusedActivity: (activity: Activity, activityType?: DialogType) => void,
  sarItem: SarsModel,
  sarsEventLookups: ReturnType<typeof useLookup>[0]
) => {
  const ApprovalBody: React.FC<{
    response: string;
  }> = ({ response }) => {
    return (
      <>
        {response ? (
          <div style={{ marginBottom: 15 }}>
            <b>Message: </b>
            <ReactMarkdown>{response}</ReactMarkdown>
          </div>
        ) : null}
      </>
    );
  };

  const sarRejected: ActivityFeedItemDefinition<{ response: string }> = {
    activityType: ActivityType.SarRejected,
    Body: ({ body }) => {
      return <ApprovalBody response={body.response} />;
    },
  };

  const emailAdded: ActivityFeedItemDefinition<EmailActivityBody> = {
    activityType: ActivityType.SarsEmail,
    Body: ({ body, activity }) => {
      const { token } = useSelector(authSelector);
      const buildGetBlob = (blobId: string) => () =>
        sarsService.downloadEmailAttachment(sarItem.id, activity.id, blobId, {
          token,
        });
      return (
        <>
          <div style={{ marginBottom: 15 }}>
            <b>Subject: </b>
            <Typography>{body.subject}</Typography>
            <b>From: </b>
            <Typography>{body.from}</Typography>
            <b>To: </b>
            <Typography>{body.to.join(", ")}</Typography>
            <b>Preview: </b>
            <Typography>{body.bodyText?.substring(0, 200)}</Typography>
            {(body.attachments?.length > 0 ?? false) && (
              <>
                <b>Attachments: </b>
                <ul style={{ padding: 0, marginLeft: 0, marginTop: 0 }}>
                  {body.attachments.map((doc) => (
                    <li key={doc.blobId} style={{ listStyleType: "none" }}>
                      {
                        <DownloadLink
                          fileName={doc.fileName}
                          getBlob={buildGetBlob(doc.blobId)}
                        />
                      }
                    </li>
                  ))}
                </ul>
              </>
            )}
            <b>Download original email: </b>
            <DownloadLink
              fileName={body.originalFileName}
              getBlob={buildGetBlob(body.originalEmailBlobId)}
            />
          </div>
        </>
      );
    },
  };

  const sarPaused: ActivityFeedItemDefinition<{
    response: string;
    reason: number;
  }> = {
    activityType: ActivityType.SarPaused,
    Body: ({ body, activity }) => (
      <>
        {body.response ? (
          <div style={{ marginBottom: 15 }}>
            <b>Response: </b>
            <ReactMarkdown>{body.response}</ReactMarkdown>
            <b>Reason: </b>
            {sarsEventLookups.find((x) => x.id === +body.reason)?.label || ""}
          </div>
        ) : null}
      </>
    ),
  };


  return [emailAdded, sarRejected, sarPaused];
};
